import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { loadGenerateOtpRequest, loadGenerateOtpResponse, loadGenerateOtpFailure } from '../actions/generate-otp.actions';
import { IGenerateOtpRequest, IGenerateOtpResponse } from '../models/generate-otp.model';

export const generateOtpKey = 'generateOtp';

export interface GenerateOtpState {
  generateOtpRequest: IGenerateOtpRequest;
  generateOtpResponse: IGenerateOtpResponse;
  generateOtpFailure: IGenericError<ErrorResponse>;
}

export const initialState: GenerateOtpState = {
  generateOtpRequest: undefined,
  generateOtpResponse: undefined,
  generateOtpFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadGenerateOtpRequest, (state, action) => ({
    ...state,
    generateOtpRequest: action.request
  })),
  on(loadGenerateOtpResponse, (state, action) => ({
    ...state,
    generateOtpResponse: action.response
  })),
  on(loadGenerateOtpFailure, (state, action) => ({
    ...state,
    generateOtpFailure: action.error
  }))
);

export const getGenerateOtpRequest = (state: GenerateOtpState) => state.generateOtpRequest;
export const getGenerateOtpResponse = (state: GenerateOtpState) => {
  return state.generateOtpResponse;
};
export const getGenerateOtpFailure = (state: GenerateOtpState) => state.generateOtpFailure;
